import {
    Box,
    Button,
    Dialog,
    Grid,
    IconButton,
    List,
    ListItem,
    ListItemIcon,
    ListItemText,
    Typography,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { CheckBox } from "@material-ui/icons";
import CloseIcon from "@material-ui/icons/Close";
import lcardLogoForFreeTrial from 'assets/lcard_logo_for_free_trial.png';
import { FC } from "react";


const useStyles = makeStyles((theme) => ({
    dialogPaper: {
        backgroundColor: "#eeeeee",
        borderRadius: 16,
        maxWidth: 700,
        // maxHeight: 700,
        padding: theme.spacing(2.25, 2.75),
        margin: theme.spacing(1.5),
        [theme.breakpoints.down("sm")]: {
            margin: theme.spacing(0.5),
            padding: theme.spacing(1.25, 1.5),
            borderRadius: 12,
            maxWidth: "calc(100% - 8px)",
        },
    },
    header: {
        position: "relative",

        marginBottom: theme.spacing(1.25),
        [theme.breakpoints.down("sm")]: {
            marginBottom: theme.spacing(0.75),
        },
    },
    closeButton: {
        position: "absolute",
        right: -theme.spacing(1),
        top: -theme.spacing(1),
        [theme.breakpoints.down("sm")]: {
            right: -theme.spacing(0.5),
            top: -theme.spacing(0.5),
        },
    },
    banner: {
        width: "100%",
        height: "auto",
        borderRadius: 12,
        marginBottom: theme.spacing(2.25),
        [theme.breakpoints.down("sm")]: {
            borderRadius: 8,
            marginTop: theme.spacing(1.5),
            marginBottom: theme.spacing(1.5),
        },
    },
    title: {
        fontWeight: 700,
        fontFamily: '"Poppins", sans-serif',
        color: "#1565c0",
        display: "flex",
        alignItems: "center",
        justifyContent: "left",
        textAlign: "left",
        gap: theme.spacing(1),
        marginBottom: theme.spacing(0.75),
        fontSize: "1.6rem",
        letterSpacing: "0.015em",
        textShadow: "0.5px 0.5px 0px rgba(0, 0, 0, 0.1)",
        WebkitFontSmoothing: "antialiased",
        MozOsxFontSmoothing: "grayscale",
        [theme.breakpoints.down("sm")]: {
            fontSize: "1rem",
            gap: theme.spacing(0.5),
            flexWrap: "wrap",
            lineHeight: 1.2,
            marginBottom: theme.spacing(0.5),
            letterSpacing: "-0.01em",
        },
    },
    subtitle: {
        fontFamily: '"Poppins", sans-serif',
        fontWeight: 400,
        color: "#515151",
        textAlign: "left",
        marginBottom: theme.spacing(0.5),
        lineHeight: 1.3,
        WebkitFontSmoothing: "antialiased",
        MozOsxFontSmoothing: "grayscale",
        [theme.breakpoints.down("sm")]: {
            marginBottom: theme.spacing(1),
            fontSize: "0.78rem",
            padding: theme.spacing(0, 0.5),
            lineHeight: 1.25,
        },
    },
    featuresContainer: {
        backgroundColor: "#f8f9fa",
        borderRadius: 12,
        padding: theme.spacing(1.75),
        marginBottom: theme.spacing(2.25),
        [theme.breakpoints.down("sm")]: {
            padding: theme.spacing(1.25),
            borderRadius: 8,
            marginBottom: theme.spacing(1.5),
        },
    },
    featureItem: {
        padding: theme.spacing(0.75, 0),
        alignItems: "flex-start",
        [theme.breakpoints.down("sm")]: {
            padding: theme.spacing(0.4, 0),
        },
    },
    checkIcon: {
        color: "#4caf50",
        minWidth: "auto",
        marginTop: -3,
        marginRight: theme.spacing(0.4),
        alignSelf: "flex-start",
        paddingTop: 0,
        paddingRight: 0,
        paddingLeft: 0,
        [theme.breakpoints.down("sm")]: {
            minWidth: "auto",
            marginRight: theme.spacing(0.4),
            paddingTop: 3,
            paddingRight: 0,
            paddingLeft: 0,
            "& svg": {
                fontSize: 18,
            },
        },
    },
    featureList: {
        [theme.breakpoints.down("sm")]: {
            paddingTop: 0,
            paddingBottom: 0,
        },
    },
    featureGridItem: {
        [theme.breakpoints.down("sm")]: {
            paddingTop: theme.spacing(0.25),
            paddingBottom: theme.spacing(0.25),
            "&:first-child": {
                paddingBottom: theme.spacing(0.25),
            },
        },
    },
    featureText: {
        fontFamily: '"Poppins", sans-serif',
        fontWeight: 400,
        fontSize: "0.9rem",
        lineHeight: 1.1,
        letterSpacing: "0.005em",
        color: "#515151",
        display: "block",
        WebkitFontSmoothing: "antialiased",
        MozOsxFontSmoothing: "grayscale",
        [theme.breakpoints.down("sm")]: {
            fontSize: "0.76rem",
            lineHeight: 1.4,
        },
    },
    listItemText: {
        margin: 0,
        paddingTop: 0,
        paddingLeft: 0,
        "& .MuiListItemText-primary": {
            display: "block",
        },
    },
    featuresGrid: {
        marginTop: theme.spacing(1.25),
        [theme.breakpoints.up("md")]: {
            "& > .MuiGrid-item": {
                paddingLeft: theme.spacing(1.5),
            },
        },
    },
    ctaButton: {
        background: "#fcc851",
        color: "#fff",
        padding: theme.spacing(.6, .9),
        borderRadius: 40,
        fontSize: 18,
        fontWeight: 700,
        textTransform: "none",
        // boxShadow: "0 4px 12px rgba(255, 152, 0, 0.4)",
        width: "max-content",
        whiteSpace: "normal",
        lineHeight: 1.4,
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        justifyContent: "center",
        "&:hover": {
            background: "#fccd62",
            // boxShadow: "0 6px 16px rgba(255, 152, 0, 0.5)",
        },
        [theme.breakpoints.down("sm")]: {
            padding: theme.spacing(.9, 1.1),
            fontSize: 13,
            borderRadius: 25,
            lineHeight: 1.3,
            fontWeight: 600,
            marginTop: theme.spacing(1.5),
            width: "max-content",
        },
    },
    buttonLogo: {
        width: 50,
        height: 50,
        marginRight: 15,
        borderRadius: 30,
        flexShrink: 0,
        [theme.breakpoints.down("sm")]: {
            width: 40,
            height: 40,
            marginRight: 8,
        },
    },
    buttonText: {
        fontFamily: '"Poppins", sans-serif',
        fontWeight: 700,
        color: "#205089",
        letterSpacing: "0.05em",
        fontSize: 20,
        lineHeight: 1.3,
        WebkitFontSmoothing: "antialiased",
        MozOsxFontSmoothing: "grayscale",
        [theme.breakpoints.down("sm")]: {
            letterSpacing: "-0.01em",
            fontSize: 16,
            fontWeight: 600,
            lineHeight: 1.2,
        },
    },
    trialBadge: {
        display: "inline-flex",
        alignItems: "center",
        backgroundColor: "#fff3e0",
        color: "#ff9800",
        padding: theme.spacing(0.5, 2),
        borderRadius: 20,
        fontWeight: 600,
        fontSize: 14,
        marginTop: theme.spacing(2),
        [theme.breakpoints.down("sm")]: {
            fontSize: 12,
            padding: theme.spacing(0.5, 1.5),
            marginTop: theme.spacing(1.5),
        },
    },
}));

export interface FreeTrialDialogProps {
    isOpen: boolean;
    onClose(): void;
    redirectUrl?: string;
}

export const FreeTrialDialog: FC<FreeTrialDialogProps> = ({
    isOpen,
    onClose,
    redirectUrl = "/pro/index/profile",
}) => {
    const classes = useStyles();

    const handleSubscribe = () => {
        window.open(redirectUrl, "_top");
    };

    const features = [
        {
            column: 1,
            items: [
                "Create unlimited digital cards — import business card designs from Canva and upload custom backgrounds",
                "Add bio, videos, call-to-action buttons, and other marketing content to promote your products and services",
            ],
        },
        {
            column: 2,
            items: [
                "Capture and manage leads automatically",
                "Scan unlimited paper cards in 38 languages and eliminate business card clutter",
                "Access advanced analytics & team tools",
                "Enable NFC smart card integration",
            ],
        },
    ];

    return (
        <Dialog
            open={isOpen}
            onClose={onClose}
            maxWidth="md"
            fullWidth
            classes={{ paper: classes.dialogPaper }}
        >
            <Box className={classes.header}>
                <IconButton
                    className={classes.closeButton}
                    onClick={onClose}
                    size="small"
                >
                    <CloseIcon />
                </IconButton>
            </Box>

            {/* 
            <img
                src={bannerFreeTrial}
                alt="Unlock Your Full Networking Power"
                className={classes.banner}
            />
            */}

            <Typography variant="h4" className={classes.title} style={{ fontFamily: '"Poppins", sans-serif' }}>
                {/* <RocketIcon style={{ fontSize: 32 }} /> */}
                UNLOCK YOUR FULL NETWORKING POWER! 🚀
            </Typography>

            <Typography variant="body1" align="center" className={classes.subtitle}>
                You're using the <strong>Basic Plan</strong> — upgrade to{" "}
                <strong style={{ color: "#1565c0" }}>L-Card Pro</strong> and access
                powerful tools that help you connect smarter, capture more leads, and
                grow your business faster.
            </Typography>

            <Grid container spacing={1} className={classes.featuresGrid}>
                {features.map((column, idx) => (
                    <Grid item xs={12} md={6} key={idx} className={classes.featureGridItem}>
                        <List dense className={classes.featureList}>
                            {column.items.map((feature, i) => (
                                <ListItem key={i} className={classes.featureItem}>
                                    <ListItemIcon className={classes.checkIcon}>
                                        <CheckBox />
                                    </ListItemIcon>
                                    <ListItemText
                                        className={classes.listItemText}
                                        primary={feature}
                                        primaryTypographyProps={{
                                            variant: "body2",
                                            className: classes.featureText,
                                        }}
                                    />
                                </ListItem>
                            ))}
                        </List>
                    </Grid>
                ))}
            </Grid>

            <Box mt={{ xs: 1.5, sm: 2.25 }} style={{ display: 'flex', justifyContent: 'center' }}>
                <Button
                    variant="contained"
                    className={classes.ctaButton}
                    onClick={handleSubscribe}
                    size="medium"
                >
                    <img src={lcardLogoForFreeTrial} alt="L-Card" className={classes.buttonLogo} />
                    <Box component="span" display="flex" flexDirection="column" alignItems="center" className={classes.buttonText} style={{ marginRight: 10 }}>
                        <span>START 14-DAY</span>
                        <span>FREE TRIAL NOW</span>
                    </Box>
                </Button>
                {/* <div className={classes.trialBadge}>
                    No credit card required • Cancel anytime
                </div> */}
            </Box>
        </Dialog>
    );
};